import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { getResource } from '@eb/resource-cache';
import { formatDate } from 'js-utils/datetime';

import { getTimeForTimePicker } from './utils';
import { initializeSchedulePublishFormData } from './actions';
import { SCHEDULE_PUBLISH_DATE, STATE_RESOURCE_CACHE_NAME } from '../constants';
import { eventCache, getPublishSettingsCacheKey } from './api';

const populateSchedulePublish = (state, eventId) => {
    const cache = state[STATE_RESOURCE_CACHE_NAME];
    const { start } = eventCache.getResource(state, { eventId }) || {};
    const publishSettings =
        getResource(cache, getPublishSettingsCacheKey(eventId)) || {};
    let eventStartDate;
    let eventStartTime;
    let eventTimezone;
    const defaultSchedulePublishDateTime =
        publishSettings[SCHEDULE_PUBLISH_DATE];
    if (!isEmpty(start)) {
        const eventStartDateLocal = start.local;

        eventStartDate = formatDate(eventStartDateLocal);
        eventStartTime = getTimeForTimePicker(eventStartDateLocal);
        eventTimezone = start.timezone;
    }
    return {
        eventStartDate,
        eventStartTime,
        eventTimezone,
        defaultSchedulePublishDateTime,
        eventId,
    };
};

export const mapStateToProps = (state, { params: { eventId } = {} }) => {
    // we can't validate the date without timezone, and event must be
    // loaded to have the timezone, so don't populate until event is ready.
    if (eventId) {
        return populateSchedulePublish(state, eventId);
    }
};

export const mapDispatchToProps = () => (dispatch) => ({
    onFormLoad: (defaultSchedulePublishDateTime, eventTimezone) => {
        dispatch(
            initializeSchedulePublishFormData(
                defaultSchedulePublishDateTime,
                eventTimezone,
            ),
        );
    },
});

const connectSchedulePublishForm = connect(mapStateToProps, mapDispatchToProps);

export default connectSchedulePublishForm;
